import * as React from 'react';
import { BaSeI18nContext } from '../../../contexts/i18n';
import { numberWithUnit } from '../../../utils/string-utils';
import { BaSeStaticAsset } from '../../static-asset/static-asset';
import { getLogoPath, LogoSebraeProps } from './logo-utils';

export const BaSeLogoSebrae: React.FC<LogoSebraeProps> = ({
  onClick,
  width = 'auto',
  easterEgg = false,
}) => {
  const { getMessage } = React.useContext(BaSeI18nContext);
  return (
    <BaSeStaticAsset
      classIdentifier="BaSe--logo-sebrae"
      description={getMessage('logo.description')}
      path={getLogoPath(easterEgg, 'images/logos/sebrae_logo')}
      onClick={onClick}
      width={numberWithUnit(width)}
    />
  );
};

BaSeLogoSebrae.displayName = 'BaSeLogoSebrae';
